import { t } from 'i18next';
import { toast } from 'react-toastify';
import {
    ALLOWED_MIME_TYPES,
    MAX_TOTAL_ATTACHMENT_BYTES,
} from '../constants/attachmentLimits';

export const validateAttachmentFile = (file: File): string | null => {
    if (!ALLOWED_MIME_TYPES.includes(file.type as typeof ALLOWED_MIME_TYPES[number])) {
        return t('formStep2.attachmentInvalidType');
    }

    if (file.size > MAX_TOTAL_ATTACHMENT_BYTES) {
        return t('formStep2.attachmentTooLarge');
    }

    return null;
};

export const showErrorToast = (message: string) => {
    toast(message, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: 'error',
    });
};
